import type { ComparablesTypes } from '@/components/comparables/ComparablesTypes'

export type ComparablesType = (typeof ComparablesTypes)[keyof typeof ComparablesTypes]

export interface ComparablesColumn {
  title: string
  visible: boolean
  size: number
}

export interface ComparablesSortInfo {
  index: number
  ascending: boolean
}

export interface ComparablesFilterCondition {
  conType: number
  compareType?: number
  expected?: string | number | boolean | Date | null
  expectTypeId?: number
  useWildCards?: boolean
  ignoreCase?: boolean
  type?: number
  item1?: ComparablesFilterCondition
  item2?: ComparablesFilterCondition
}

export interface ComparablesFilter {
  index: number
  conditions: ComparablesFilterCondition[] | null
}

export interface ComparablesState {
  compsType: ComparablesType
  classificationSelected: string
  outliersIncluded: boolean
  initializing: boolean
  secondInitPending: boolean
  hasPersistedState: boolean
  originalColumnSet: ComparablesColumn[]
  customColumnSet: ComparablesColumn[]
  filterItemMap: ComparablesFilter[]
  sortInfo: ComparablesSortInfo | Record<string, never>
  fxSetting: Partial<Record<ComparablesType, string>>
}

export const getDefaultState = (): ComparablesState => {
  return {
    compsType: 'company',
    classificationSelected: 'Industry Group (L2)',
    outliersIncluded: false,
    initializing: false,
    secondInitPending: false,
    hasPersistedState: false,
    originalColumnSet: [],
    customColumnSet: [],
    filterItemMap: [],
    sortInfo: {},
    fxSetting: {
      company: 'RAW',
      sector: 'USD',
    },
  }
}
export default getDefaultState()
